import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { Venue } from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

export interface VenueQuery {
	size: number;
	page: number;
	sort: string;
	name: string;
	city: string;
	postalCode: string;
}

export interface PaginationConfig {
	itemsPerPage: number;
	totalItems: number;
	currentPage: number;
}

@Injectable()
export class VenueApi {
	private _venuesUrl = '/api/venues/v2/venues';


	constructor(private httpClient: HttpClient, private logger: Logger) {
	}

	public getVenues(): Observable<Venue[]> {
		return this.httpClient.get(this._venuesUrl)
			.map(response => response.json().content)
			.catch(this.handleError);
	}

	public getVenueById(id: string): Observable<Venue> {
		this.logger.info("Get Venue by Id:" + id);
		return this.httpClient.get(this._venuesUrl + "/" + id)
			.map(response => <Venue>response.json())
			.catch(this.handleError);
	}

	public createVenue(venue: Venue): Observable<Venue> {
		let body = JSON.stringify(venue);
		this.logger.info("Save Venue: " + venue.name);
		return this.httpClient.post(this._venuesUrl, body)
			.map(response => <Venue>response.json())
			.catch(this.handleError)
	}

	public updateVenue(id: string, venue: Venue): Observable<Venue> {
		let body = JSON.stringify(venue);
		this.logger.info("Update Venue [" + id + "]: " + venue.name);
		return this.httpClient.patch(this._venuesUrl + "/" + id, body)
			.map(response => <Venue>response.json())
			.catch(this.handleError)
	}

	public deleteVenue(id: string): Observable<Response> {
		this.logger.info("Delete Venue[" + id + "]");
		return this.httpClient.delete(this._venuesUrl + "/" + id)
			.catch(this.handleError)
	}

	public autocomplete(query: string): Observable<Venue[]> {
		return this.httpClient.get(this._venuesUrl + "/search/autocompleteForMerchant?name=" + query + "&city=" + query + "&postalCode=" + query)
			.map(response => <Venue[]>response.json()._embedded.venues)
			.catch(this.handleError)
	}

	public search(venueQuery: VenueQuery) {
		return this.httpClient.get(this._venuesUrl + "/search/searchVenueForMerchant?size=" + venueQuery.size + "&page=" + venueQuery.page +
			"&sort=" + venueQuery.sort + "&name=" + venueQuery.name + "&city=" + venueQuery.city + "&postalCode=" + venueQuery.postalCode)
			.map(response => response.json())
			.catch(this.handleError);
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error.json());
	}

}



// WEBPACK FOOTER //
// ./src/app/services/webservice/venue-api.service.ts